import Header from './MainHeader';
import Footer from './MainFooter';
import ViewportDebug from './ViewportDebug';

export default function layout({ children }) {
    return (
        <>
            <Header />
            <main>{children}</main>
            <Footer />
            {/* Renders only with ?viewport=1 in the URL - see components/ViewportDebug */}
            <ViewportDebug />
        </>
    )
}
